import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/links';
type CtaButtonProps = {
  label: string;
  id?: string;
  className?: string;
  size?: 'md' | 'lg';
};
export function CtaButton({
  label,
  id,
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizeClass = size === 'lg' ? 'px-6 py-[1.1rem] text-[1.05rem] sm:text-lg' : 'px-5 py-3.5 text-base';
  return <a id={id} href={CHECKOUT_URL} className={`group inline-flex w-full items-center justify-center gap-2.5 rounded-2xl bg-cta font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#c24a07,0_14px_30px_-10px_rgba(255,106,19,0.6)] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-ctaDark active:translate-y-[3px] active:shadow-[0_3px_0_0_#c24a07] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:w-auto ${sizeClass} ${className}`} style={{
    textWrap: 'balance'
  } as React.CSSProperties} data-id="element-93" data-mp="qj93cuqwk590">
      <span className="text-center" data-id="element-94" data-mp="35y7h29yk0owv">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-95" data-mp="39yrg5j2ou2ln" />
    </a>;
}